import { useQuery } from '@tanstack/react-query'
import { BoosterMilestoneCompletion, BoosterProgramDetailStats } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { mapApiToProgramDetailStats } from 'modules/booster-program/api-adapters'
import { logError } from 'utils/logger'

import { boosterProgramKeys } from './query-keys'

const EMPTY: { stats: BoosterProgramDetailStats; milestoneCompletion: BoosterMilestoneCompletion[] } = {
  stats: { totalEnrolled: 0, activeEnrolledUsers: 0, codesIssued: 0, codesApplied: 0 },
  milestoneCompletion: [],
}

const fetchDetailStats = async (programId: string) => {
  try {
    const res = await AppAdmin.getBoosterProgramDetailStats(programId)
    if (!res.data?.success || !res.data.data) return EMPTY
    return mapApiToProgramDetailStats(res.data.data)
  } catch (error) {
    logError('Error fetching booster program detail stats:', error)
    return EMPTY
  }
}

export const useBoosterProgramDetailStats = (programId: string | undefined) => {
  const query = useQuery({
    queryKey: [...boosterProgramKeys.detail(programId), 'stats'] as const,
    queryFn: () => fetchDetailStats(programId!),
    enabled: !!programId,
  })

  return {
    stats: query.data?.stats ?? EMPTY.stats,
    milestoneCompletion: query.data?.milestoneCompletion ?? EMPTY.milestoneCompletion,
    isLoading: query.isLoading,
  }
}
